import {
  DataClassification,
  DataField,
  DataFieldType,
  EnumObjects,
  EventFlags,
  TelemetryProperties,
  TelemetrySink,
} from '@microsoft/oteljs'

import { log } from './global-log'
import { OTelConfig, OTelSink } from './otel-sink'

export type RichApiDataField = {
  name: string
  value: string | number | boolean
  classification: DataClassification
  // tslint:disable-next-line: no-reserved-keywords
  type?: DataFieldType
}

export type SendTelemetryEventHandler = (
  telemetryProperties: TelemetryProperties,
  eventName: string,
  contractName: string,
  eventFlags: EventFlags,
  dataFields: RichApiDataField[]
) => void

const convertDataField = (df: DataField) => {
  const { dataType: type, ...rest } = df

  return {
    classification: EnumObjects.DataClassification.SystemMetadata,
    type,
    ...rest,
  }
}

export const createSendTelemetryEventSink = (
  sendTelemetryEventHandler: SendTelemetryEventHandler
) =>
  ({
    sendTelemetryEvent: event =>
      // tslint:disable-next-line: no-unsafe-any
      sendTelemetryEventHandler(
        {
          ariaTenantToken: '',
          nexusTenantToken: 0,
          ...event.telemetryProperties,
        },
        event.eventName,
        (event.eventContract && event.eventContract.name) || '',
        {
          costPriority: EnumObjects.CostPriority.Normal,
          dataCategories: EnumObjects.DataCategories.ProductServicePerformance,
          diagnosticLevel: EnumObjects.DiagnosticLevel.FullEvent,
          persistencePriority: EnumObjects.PersistencePriority.Normal,
          samplingPolicy: EnumObjects.SamplingPolicy.Measure,
          ...event.eventFlags,
        },
        [
          ...(event.dataFields || []).map(convertDataField),
          ...(
            (event.eventContract && event.eventContract.dataFields) ||
            []
          ).map(convertDataField),
        ]
      ),
  } as TelemetrySink)

export const initializeSendTelemetryEventLogger = (
  otelConfig: OTelConfig,
  sendTelemetryEventHandler: SendTelemetryEventHandler
) => {
  log.addSink(
    new OTelSink(
      otelConfig,
      createSendTelemetryEventSink(sendTelemetryEventHandler)
    )
  )
}
